export default __webpack_public_path__ + "static/media/EricEllenGerald400.cfc48189.jpg";